import { WebviewId } from '@gitlab-org/webview-plugin';

export type ExtensionMessage = {
  webviewId: WebviewId;
  type: string;
  payload: unknown;
};

export const isExtensionMessage = (message: unknown): message is ExtensionMessage => {
  return (
    typeof message === 'object' && message !== null && 'webviewId' in message && 'type' in message
  );
};
